import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export const ModuleTextHeadline = ({ data, editing, className, onChange }: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const moduleClasses = clsx({ ...className.module });
  const containerClasses = clsx({ ...className.container }, 'px-0', 'relative');
  const colNumbers = content.field_num_columns;
  const columnClasses = clsx({
    'o-text--multi-col-2': colNumbers === 2 || colNumbers === 3,
    'o-text--multi-col-3': colNumbers === 3,
  });
  const widthClasses = clsx({
    col: true,
    'col-12': true,
    'col-lg-8': colNumbers < 2,
    'col-lg-12': colNumbers >= 2,
  });

  return (
    <div className={moduleClasses} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={containerClasses}>
        <div className="row c-module__header">
          <div className={widthClasses}>
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="row c-module__content">
          {content.field_text ? (
            <div className={clsx(widthClasses, 'u-margin-top-sm o-field-text')}>
              <div className={columnClasses} style={{ transform: 'translateX(0px)' }}>
                <EditableField
                  entityType={data.type}
                  fieldName="attributes.field_text.value"
                  data={content.field_text.value}
                  editing={editing}
                  onChange={onChange}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ModuleTextHeadline;
